import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DatePicker from 'components/@common/Inputs/DatePicker';
import { HwtButton } from 'components/@common/Buttons/HwtButton';
import { translate } from 'translations/translator';
import T from 'translations/variants/lessonPlanner';
import CommonTranslationVariant from 'translations/variants/common';

const getTranslation = (key: T) => translate('lessonPlanner', key);
const translateCommon = (key: CommonTranslationVariant) => translate('common', key);

type Props = {
  handleSave: (startDate: string) => void;
  startDate: any;
};

export const ManageSchoolStartDate: React.FC<Props> = ({ handleSave, startDate }) => {
  const [selectedDate, setSelectedDate] = React.useState<any>(new Date(startDate));
  const classes = useStyles();

  const handleCalendarChange = (_, value) => setSelectedDate(value);
  return (
    <Container style={{ marginTop: 32 }}>
      <Box>
        <Typography variant="h4" style={{ fontWeight: 400 }}>
          {getTranslation(T.editSchoolStartDate)}
        </Typography>
        <Typography variant="h6" style={{ fontWeight: 300 }}>
          {getTranslation(T.editSchoolStartDateDescription)}
        </Typography>
        <Box display="flex">
          <DatePicker
            label={getTranslation(T.schoolStartDate)}
            sx={{ width: '485px' }}
            name={translateCommon(CommonTranslationVariant.chooseDate)}
            value={selectedDate}
            onChange={handleCalendarChange}
            shouldDisableWeekends
          />
          <HwtButton
            className={classes.btn}
            variant="contained"
            disabled={!selectedDate}
            onClick={() => handleSave(selectedDate)}
          >
            {getTranslation(T.saveChanges)}
          </HwtButton>
        </Box>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  actionGroup: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    alignSelf: 'flex-end',
    margin: '8px 25px 2px 25px !important',
    height: '53px !important',
    width: 'max-content !important'
  }
}));
